import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '../../../../Components/MUIs';
import BottomSheet from '../../../../Components/Ui/BottomSheet';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useSelector } from 'react-redux';

export default function RejectBottomSheet({
  Save1,
  title = '반려',
  label = '반려 사유를 입력하세요',
}) {
  const [returnDetail, setReturnDetail] = useState('');
  const dispatch = useDispatch();
  const { baseInfo } = useSelector((state) => state.permit);
  console.log('baseInfo', baseInfo);

  const handleReject = () => {
    Save1({ gubun: '0', returnDetail });
    dispatch(BottomSheetActions.CloseBottomSheet());
    dispatch(showSnackbar({ message: '반려되었습니다.', type: 'success' }));
  };
  return (
    <BottomSheet
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
        >
          {baseInfo.mst.reqNm}님의 작업허가서를&nbsp;
          <span style={{ color: '#FF0000' }}>{title}</span>
          합니다.
        </Typography>
      }
    >
      <Box sx={{ px: 1 }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          근로자가 알아볼 수 있도록 <br /> 꼼꼼히 작성해주세요 :)
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            display: 'flex',
          }}
        >
          반려 내용
        </Typography>
        <textarea
          type="text"
          value={returnDetail || ''}
          onChange={(e) => setReturnDetail(e.target.value)}
          tabIndex={-1}
          style={{
            width: '100%',
            padding: '14px 16px',
            borderRadius: '8px',
            outline: 'none',
            fontSize: '16px',
            backgroundColor: '#F8F8F8',
            border: 'none',
            transition: 'border-color 0.3s ease',
            minHeight: '10rem',
            resize: 'none',
            boxSizing: 'border-box',
          }}
          placeholder={label}
        />
      </Box>
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Button
          name="반려하기"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#FF6161',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={handleReject}
        />
      </Box>
    </BottomSheet>
  );
}
